<template>
    <div id="app">
        <transition name="fade"
                    mode="out-in">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'app',
        components: {}
    }

</script>

<style lang="scss">
    body {
        margin: 0px;
        padding: 0px;
        background-image: url(assets/bg.png) !important;
        background-size: cover;
        background: #439edc;
        font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
        font-size: 14px;
        -webkit-font-smoothing: antialiased;
    }
    .el-menu-item [class^=fa]{
        color: #ffffff;
    }

    .el-submenu .el-menu-item:hover, .el-submenu__title:hover {
        background-color: #3c9298 !important;
    }

    .el-submenu__title {
        padding: 0 !important;
    }
    .container .el-submenu li.el-menu-item{
        font-size: 15px !important;
        padding: 0 20px !important;
    }

    #app {
        position: absolute;
        top: 0px;
        bottom: 0px;
        width: 100%;
    }
    .ql-editor{
        height:150px !important;
    }

    .el-submenu [class^=fa] {
        vertical-align: baseline;
        margin-right: 10px;
    }

    .el-menu-item [class^=fa] {
        vertical-align: baseline;
        margin-right: 10px;
    }

    .toolbar {
        background: #f2f2f2;
        padding: 10px;
        //border:1px solid #dfe6ec;
        margin: 10px 0px;

        .el-form-item {
            margin-bottom: 10px;
        }
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: all .2s ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0;
    }

    .el-dialog__headerbtn {
        position: absolute;
        top: 20px;
        right: 20px;
        padding: 0;
        background: transparent;
        border: none;
        outline: none;
        cursor: pointer;
        font-size: 16px;
    }

    .note {
        color: #cccccc;
        margin-top: 0;
        line-height: 20px;
    }
    ul.el-menu.collapsed .el-menu-item{
        min-width: 0;
        max-width: 100%;
    }
    .el-upload,.el-upload-dragger{
        width: 100% !important;
    }
    .cell .el-tag {
        margin: 5px;
    }
    .transaction-row{
        color: #51cf38;
    }
    .reported-row{
        color: red;
    }
    .green-row{
        color: #89b96c;
    }
    .cell label{
        font-weight: bold;
        font-size: 16px;
    }
    .el-table .cell{
        word-break: break-word !important;
    }
</style>


// WEBPACK FOOTER //
// App.vue?b03ee1f4